import React, { FC } from 'react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { KompisFakeData } from '@inter-ikea-kompis/react-components';
import { DeviceType, ProductInfo } from 'sofa-reborn-react';
import { IProduct } from '@inter-ikea-kompis/types';

import SkapaModal, {
	Sheets as SkapaSheets,
	ModalHeader as SkapaModalHeader,
	ModalBody as SkapaModalBody,
} from '@ingka/modal';

type Props = {
	deviceType: DeviceType;
	productInfo: ProductInfo | null;
	onCloseFakeDataForm?: () => void;
	onLoadFakeData?: (e) => void;
};

const getProductInfoAsArray = (productInfo: ProductInfo | null): IProduct[] => {
	const productArray: IProduct[] = [];
	if (productInfo) {
		Object.values(productInfo).forEach((product) => {
			productArray.push(product);
		});
	}

	return productArray;
};

const FakeData: FC<Props> = (props) => {
	const { onCloseFakeDataForm } = props;
	return (
		<SkapaModal
			visible={true}
			handleCloseBtn={(): void => onCloseFakeDataForm && onCloseFakeDataForm()}
		>
			<SkapaSheets
				size={'small'}
				header={<SkapaModalHeader title={'Fake Data'} />}
				footer={null}
				style={{
					zIndex: 10,
					borderTop:
						SkapaTheme.border.thickness.thin + 'px solid' + SkapaTheme.color.border.default,
					borderBottom:
						SkapaTheme.border.thickness.thin + 'px solid' + SkapaTheme.color.border.default,
				}}
			>
				<SkapaModalBody>
					<KompisFakeData
						onApplyChanges={(e): void => props.onLoadFakeData && props.onLoadFakeData(e)}
						theme={SkapaTheme}
						products={getProductInfoAsArray(props.productInfo)}
					/>
				</SkapaModalBody>
			</SkapaSheets>
		</SkapaModal>
	);
};

export default FakeData;
